import AuditField from "./AuditField";

export default function BlocRevenus({ data }) {
  const i = data.impots || {};
  const r = data || {};

  return (
    <section className="space-y-6 bg-white p-6 rounded-xl shadow">
      <h2 className="text-xl font-bold text-gray-800">Revenus & Fiscalité</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {/* Activité & Revenus */}
        <AuditField label="Profession" value={r.profession} />
        <AuditField label="Entreprise" value={r.entreprise} />
        <AuditField label="Ancienneté" value={r.anciennete} />
        <AuditField label="Type de contrat" value={r.typeContrat} />
        <AuditField label="Régime" value={r.regime} />
        <AuditField label="Revenus bruts annuels" value={r.revenusBrutsAnnuels + " €"} />
        <AuditField label="Revenus nets annuels" value={r.revenusNetsAnnuels + " €"} />
        <AuditField label="Revenu fixe" value={r.revenuFixe + " €"} />
        <AuditField label="Revenu variable" value={r.revenuVariable + " €"} />
        <AuditField label="Retraite" value={r.retraite + " €"} />
        <AuditField label="Pension versée" value={r.pensionVersee + " €"} />
        <AuditField label="Pension reçue" value={r.pensionRecue + " €"} />
        <AuditField label="Dividendes" value={r.dividendes + " €"} />
        <AuditField label="Bénéfice / déficit foncier" value={r.beneficeDeficitFoncier + " €"} />

        {/* Fiscalité */}
        <AuditField label="Revenu imposable" value={i.revenuImposable + " €"} />
        <AuditField label="Revenu global imposable" value={i.revenuImposableGlobal + " €"} />
        <AuditField label="Nombre de parts" value={i.nombreParts} />
        <AuditField label="TMI" value={i.tmi + " %"} />
        <AuditField label="Impôts avant réduction" value={i.impotsAvantReduction + " €"} />
        <AuditField label="Impôts après réduction" value={i.impotsApresReduction + " €"} />
        <AuditField label="Impôts payés N-1" value={i.impotsPayesN1 + " €"} />
        <AuditField label="Réduction : Salarié à domicile" value={i.reductions?.salarieDomicile ? "Oui" : "Non"} />
        <AuditField label="Réduction : Dons aux œuvres" value={i.reductions?.donsOeuvres ? "Oui" : "Non"} />
        <AuditField label="Réduction : Défiscalisation" value={i.reductions?.defiscalisation ? "Oui" : "Non"} />
        <AuditField label="Réduction : Divers" value={i.reductions?.divers ? "Oui" : "Non"} />
        <AuditField label="Remarques fiscales" value={i.remarques} />
      </div>
    </section>
  );
}
